import { addMode, editMode, deleteMode, magnifyMode, USER_DESIG, EyeTypes, ANNOTATION_COLORS, DEFAULT_VIEW_TYPE, EYES_ORDER_TYPE, COLOR_TYPE, shapeFillMode } from "../config/config";
import { canSaveBlobs } from "../helpers/blobsaver";

export const windowWidth = state => state.windowWidth;
export const widthXs = (state, getters) => getters.windowWidth < 600;
export const widthSm = (state, getters) => getters.windowWidth >= 600 && getters.windowWidth < 960;
export const widthMd = (state, getters) => getters.windowWidth >= 960 && getters.windowWidth < 1264;
export const widthLg = (state, getters) => getters.windowWidth >= 1264 && getters.windowWidth < 1904;
export const widthXl = (state, getters) => getters.windowWidth >= 1904;
export const widthLandscape = (state, getters) => getters.windowWidth <= 1024;
export const widthTablet = (state, getters) => getters.windowWidth <= 1700;
export const windowHeight = state => state.windowHeight;
export const heightXs = (state, getters) => getters.windowHeight < 500;
export const heightSm = (state, getters) => getters.windowHeight >= 500 && getters.windowHeight < 701;
export const heightMd = (state, getters) => getters.windowHeight >= 701 && getters.windowHeight < 900;
export const heightLg = (state, getters) => getters.windowHeight >= 900;
export const belowMobileCutoff = (state, getters) =>
  getters.windowWidth < 700 || getters.windowHeight < 600;

// #region auth
export const allowUnsecuredSSO = state => state.allowUnsecuredSSO;
export const auth = state => state.auth;
export const isAuthenticated = state => !!(state.auth && state.auth.access_token);
export const user = state => state && state.auth && state.auth.user;
export const userFullName = (state, getters) =>
  getters.user ? getters.user.FName + " " + getters.user.LName : "";
export const deptName = (state, getters) => getters.user && getters.user.Dept;
export const userDesig = (state, getters) => getters.user && getters.user.Desig;
export const userIsAdmin = (state, getters) => getters.userDesig === USER_DESIG.Admin;
export const userIsAttdMD = (state, getters) => getters.userDesig === USER_DESIG.AttdMD;
export const userIsRefMD = (state, getters) => getters.userDesig === USER_DESIG.RefMD;
export const userIsPhotographer = (state, getters) => getters.userDesig === USER_DESIG.Photographer;
export const userIsUser = (state, getters) => getters.userDesig === USER_DESIG.User;
export const userIsViewOnly = (state, getters) => getters.userDesig === USER_DESIG.ViewOnly;
export const userIsReadOnly = (state, getters) => getters.userDesig === USER_DESIG.ReadOnly;
export const canAnnotate = (state, getters) => !getters.userIsRefMD;
export const canDownload = (state, getters) => !getters.isOpenedInApp && canSaveBlobs;
export const canDownloadExam = (state, getters) => getters.canDownload && (getters.userIsAdmin || getters.userIsPhotographer || getters.userIsUser || getters.userIsAttdMD);
export const canDelete = (state, getters) => getters.userIsAdmin || getters.userIsPhotographer;
export const canEditPathology = (state, getters) => getters.userIsAdmin || getters.userIsPhotographer || getters.userIsUser || getters.userIsAttdMD;
export const usrSrNo = (state, getters) => getters.user && getters.user.usrSrNo;
export const usrMustChangePwd = (state, getters) => getters.user && getters.user.ChangePWDMust;
export const hideUserPref = (state, getters) => getters.user && getters.user.UserPrefMenu;
export const isIdle = state => state.isIdle;
export const disableAutoLogout = state => state.disableAutoLogout;
export const backgroundTimestamp = state => state.backgroundTimestamp;
export const refreshTokenExpirationTime = state => state.auth && state.auth.expires_time;
export const MfaEnabled = state => state.mfa.enabled;
export const MfaSecret = state => state.mfa.secret;
export const userPrefs = state => state.userPrefs;
export const userPrefsFullscreen = state => state.userPrefs && state.userPrefs.fullscreen && state.userPrefs.fullscreen == 1;
export const userPrefHVF = state => state.userPrefs && state.userPrefs.defaultHVF;
export const userPrefCirrusView = state => state.userPrefs && state.userPrefs.defaultCirrusView;
export const userPrefBlackAndWhiteCirrusView = state => state.userPrefs && state.userPrefs.defaultCirrusView == COLOR_TYPE.blackWhite;
export const userPracticeGroupIds =(state, getters) => getters.user ? getters.user.PracticeGroupId : []; 
export const userAutoPatientExamRefresh = state => state.userPrefs && state.userPrefs.autoPatientExamRefresh;
export const hvfOrder = (state, getters) => {
  if (getters.userPrefHVF != null) return getters.userPrefHVF == EYES_ORDER_TYPE.OS_OD ? true : false;
  return getters.useDefaultHvf;
}
export const defaultHVFVIEW = (state, getters) =>{
  if(getters.userPrefs.defaultHVFview)
    return getters.userPrefs.defaultHVFview;
  else if(getters.siteInfo.siteDefaultHVFview !== "")
    return getters.siteInfo.siteDefaultHVFview;
  else return DEFAULT_VIEW_TYPE.singleView;
}
export const defaultColorTheme = state => state.userPrefs && state.userPrefs.defaultColorTheme;
export const multiviewCollapseUserPref = state => state.userPrefs && state.userPrefs.multiviewCollapse;
export const cirrusScanDisplayRatio = state => state.userPrefs && state.userPrefs.cirrusScanDisplayRatio;
export const calledFullscreenToggle = state => state.calledFullscreenToggle;
// #endregion

export const isOpenedInApp = state => state.isOpenedInApp;
export const isIE = state => state.isIE;
export const isIOS = state => state.isIOS;
export const isSafari = state => state.isSafari;
export const hasWebgl = state => state.hasWebgl;
export const webglMaxTexture = state => state.webglMaxTexture;
export const isFullscreen = state => state.isFullscreen;

export const statusMessage = state => state.status && state.status.message;
export const statusLevel = state => state.status && state.status.level;
export const statusTimeout = state => state.status && state.status.timeout;

export const physicians = state => state.physicians;
export const devices = state => state.devices;
export const deviceLogs = state => state.deviceLogs;
export const devTypes = state =>{
  let list = [];
  state.devices.forEach(e =>{
    if(e.description.toLowerCase().indexOf("hiddendev") === -1 && !list.some(el => el.value === e.type)){
      list.push({value:e.type, text:e.type});
    }
  });
  return list;
};
export const devLocations = state => state.devLocations;
export const deviceBySrNo = state => devSrNo => state.devices.find(d => d.devSrNo === devSrNo);
export const procedures = state => state.procedures;
export const practiceGroupsList = state => state.practiceGroupsList;
export const userList = state => state.userList;

export const siteInfo = state => state.siteInfo;
export const defaultPatientListing = state => state.siteInfo.defaultPatientListing;
export const axisTitle = state => state.siteInfo && state.siteInfo.axisTitle;
export const preLoadFullImage = state => state.siteInfo && state.siteInfo.preloadLargeViewImages;
export const preLoadOption = state => state.siteInfo && state.siteInfo.preLoadOption;
export const autoLogoutTimer = state => state.siteInfo && state.siteInfo.userInactivityTimeLimit;
export const allowUISSO = state => state.siteInfo && state.siteInfo.allowUISSO;
export const axis5Version = state => state.siteInfo && state.siteInfo.axis5Version;
export const onlineHelp = state => state.siteInfo && state.siteInfo.onlineHelp;
export const useDefaultHvf = state => state.siteInfo && state.siteInfo.useDefaultHvf;
export const autoRefreshPatientList = state => state.siteInfo && state.siteInfo.autoRefreshPatientList;
export const isActDirEnabled = state => state.isActDirEnabled;
export const exLnchEnabled = state => state.siteInfo.exLnchEnabled;
export const exLnchTitle = state => state.siteInfo.exLnchTitle;
export const exLnchURL = state => state.siteInfo.exLnchURL;
export const axis5DefaultFontSize = state => state.siteInfo && state.siteInfo.axis5DefaultFontSize;
export const enableSavingWithEmrPro = state => state.siteInfo && state.siteInfo.enableSavingWithEmrPro;
export const restrictInIE = state => state.siteInfo.restrictInIE; 
export const multiviewCollapseByDefault = state => state.siteInfo.multiviewCollapseByDefault;
export const downloadPNGImage = state => state.siteInfo.downloadPNGImage;
export const siteCirrusScanDisplayRatio = state => state.siteInfo.cirrusScanDisplayRatio;
export const userLockoutEnabled = state => state.siteInfo.userLockoutEnabled;
export const userLockoutDuration = state => state.siteInfo.userLockoutDuration;
export const userFailedLoginAttempts = state => state.siteInfo.userFailedLoginAttempts;
export const userFailedLoginAttemptsReset = state => state.siteInfo.userFailedLoginAttemptsReset;

// #region patient search
export const searchTimespan = state => state.patientSearch.timespan;
export const searchKeyword = state => state.patientSearch.keyword;
export const patientSearch = state => state.patientSearch;
export const advancedSearchDialog = state => state.advancedSearchDialog;
export const wasEmrPro = state => state.wasEmrPro;
export const ssoSearch = state => state.ssoSearch;
export const ssoExType = (state, getters) => getters.ssoSearch && getters.ssoSearch.extype;
export const ssoExDate = (state, getters) => getters.ssoSearch && getters.ssoSearch.exdate;
export const ssoExSrNo = (state, getters) => getters.ssoSearch && getters.ssoSearch.exsrno;
export const ssoEmrPro = (state, getters) => ((getters.ssoSearch && getters.ssoSearch.emrpro) + "").toLowerCase() === "true" || getters.wasEmrPro;
export const patientSearchOptions = state => state.patientSearchOptions;
export const emrProSearchParams = state => state.emrProSearchParams;
export const emrProExSrNo = state => state.emrProSearchParams && state.emrProSearchParams.exsrno;
// #endregion

export const patients = state => state.patients;
export const totalPatients = state => state.totalPatients;
export const loadingPatients = state => state.loadingPatients;
export const patient = state => state.patient;
export const ptSrNo = state => state.patient && state.patient.ptSrNo;
export const ptId = state => state.patient && state.patient.ptId;
export const ptSex = state => state.patient && state.patient.gender;

// #region exams
export const exams = state => state.exams || [];
export const selectedExams = state => state.selectedExams || [];
export const visualFieldExams = (state, getters) => {
  let list = getters.exams.filter(e => {
    let device = getters.devices.find(d => d.devSrNo == e.devSrNo);
    let description = device.description.toLowerCase();
    return description.includes("visual field") || description.includes("hvf")
  });
  return list; 
}
export const loadingExams = state => state.loadingExams;
export const examBySrNo = state => exSrNo => state.exams.find(e => e.exSrNo === exSrNo);
export const octExams = (state, getters) => state.exams
  .filter(e => e.isOCT && e.isScans)
  .filter(e => getters.currentEye === EyeTypes.OD || e.osGroups.length)
  .filter(e => getters.currentEye === EyeTypes.OS || e.odGroups.length);
  
function generateExamsFromGroup(exam, groupKey, groups) {
  let newExam, results = [];
  exam[groupKey].forEach(e => {
    if (groups.filter(f => f.groupSeriesType == e.groupSeriesType).length > 0) {
      newExam = Object.assign({}, exam);
      newExam.scanType = e.scanType;
      if (e.browserType != 1)
        newExam.octDateButtonText = exam.dateDisplay + " - " + e.eye + " " + e.groupSeriesType + " (" + exam.exSrNo + ")";
      else
        newExam.octDateButtonText = exam.dateDisplay + " - " + e.groupSeriesType + " (" + exam.exSrNo + ")";
      newExam[groupKey] = [e];
      results.push(newExam);
    }
  });
  return results;
}

export const octExamsWithScanTypes = (state, getters) => {
  let exams, filteredExams, groupSplitExams = [];
  exams = getters.octExams;
  let groupkey = getters.currentEye === "OD" ? "odGroups" : "osGroups";
  filteredExams = exams.filter(function(item, index) {
    if (exams.indexOf(item) == index)
      return item;
  });
  filteredExams.forEach(e => {
    let groups = getters.groups(e, getters.currentEye);
    if (getters.groups(e, getters.currentEye).length > 1) {
      groupSplitExams.push(...generateExamsFromGroup(e, groupkey, groups));
    }
    else {
      if (!e.octDateButtonText.includes(getters.groups(e, getters.currentEye)[0].groupSeriesType))
        e.octDateButtonText = e.dateDisplay + " - " + getters.groups(e, getters.currentEye, getters.currentOCTBrowserType, 0)[0].groupSeriesType + " (" + e.exSrNo + ")";
      e.scanType = getters.groups(e, getters.currentEye)[0].scanType;
      groupSplitExams.push(e);
    }
  });
  return groupSplitExams;
}

export const currentOCTExam = (state, getters) => {
  let groups = getters.currentEye === "OD" ? getters.exam.odGroups : getters.exam.osGroups;
  let recognized = groups.filter(g => g.recognized)
    .filter(g => !getters.currentGroup || g.groupName === getters.currentGroup);
  if (getters.dropdownItems)
    return getters.dropdownItems.find(e => e.exSrNo === getters.exSrNo && e.octDateButtonText.includes(recognized[0].groupSeriesType));
  return null;
};

export const selectedDropdownItem = state => state.imageBrowserContext && state.imageBrowserContext.selectedDropdownItem;

export const examToDelete = state => state.examToDelete;
export const examToDownload = state => state.examToDownload;
export const examsToDelete = state => state.examsToDelete;
export const examToEditPhysician = state => state.examToEditPhysician;
export const examToEditDiagnosis = state => state.examToEditDiagnosis;
export const examToEdit = state => state.examToEdit;
// #endregion

export const imageMap = state => state.imageMap;
export const imageByKey = state => imgKey => state.imageMap.find(i => i.imgKey === imgKey);
export const imagesByExSrNo = state => exSrNo => state.imageMap.filter(i => i.exSrNo === exSrNo);
export const imagesByPtSrNo = state => ptSrNo => state.imageMap.filter(i => i.ptSrNo === ptSrNo);
export const imagesForExams = state => exams => state.imageMap.filter(image => exams.some(exam => exam.exSrNo === image.exSrNo));
export const imageByFlSrNo= state => flSrNo => state.imageMap.find(i => i.flSrNo === flSrNo);

export const imagesOrderByExSrNo = state => exSrNo => state.imageOrder.filter(i => i.exSrNo === exSrNo);

export const octImagesForCurrentBrowser = (state, getters) =>
  state.octImageMap.filter(i => i.exSrNo === getters.exSrNo
    && i.groupName === getters.currentGroup);

// #region image browser context
export const imageBrowserContext = state => state.imageBrowserContext;
export const exam = state => state.imageBrowserContext && state.imageBrowserContext.exam;
export const exSrNo = state => state.imageBrowserContext && state.imageBrowserContext.exSrNo;
export const isOptos = (state, getters) => getters.exam && getters.exam.isOptos;
export const browserImages = (state, getters) => getters.imageBrowserContext && getters.imageBrowserContext.images || [];
export const showMeasurementSection = state => state.imageBrowserContext && state.imageBrowserContext.showMeasurementSection;
export const showPlaybackToolbar = state => state.imageBrowserContext && state.imageBrowserContext.showPlaybackToolbar;
export const showImageDrawer = state => state.imageBrowserContext && state.imageBrowserContext.showImageDrawer;
export const imageTransform = state => state.imageBrowserContext && state.imageBrowserContext.transform;
export const maxZoom = state => state.imageBrowserContext && state.imageBrowserContext.transform && state.imageBrowserContext.transform.maxZoom;
export const deepDeeHighlight = state => state.imageBrowserContext && state.imageBrowserContext.deepDeeHighlight;
export const deepDeeAnnotation = state => state.imageBrowserContext && state.imageBrowserContext.deepDeeAnnotation;
export const showDeepDeeAnnotation = state => state.imageBrowserContext && state.imageBrowserContext.showDeepDeeAnnotation;
export const seriesType = state => state.imageBrowserContext && state.imageBrowserContext.seriesType;

// #region current image and thumbnail
export const currentBrowserImage = state =>
  state.imageBrowserContext && state.imageBrowserContext.image;
export const imgNotFound = (state, getters) =>
  !!(getters.currentBrowserImage && getters.currentBrowserImage.imgNotFound);
export const imgAvailable = (state, getters) =>
  !!(getters.currentBrowserImage && !getters.currentBrowserImage.imgNotFound);
export const hasFullImage = (state, getters) =>
  !!(getters.imgSize && getters.imgSize.w && getters.imgSize.h);
export const imgObject = (state, getters) =>
  getters.currentBrowserImage && getters.currentBrowserImage.imgHtmlObject;
export const thumbObject = (state, getters) =>
  getters.currentBrowserImage && getters.currentBrowserImage.thumbHtmlObject;
export const displayImgObject = (state, getters) =>
  getters.hasFullImage ? getters.imgObject : getters.thumbObject;
export const thumbSize = (state, getters) =>
  getters.currentBrowserImage && getters.currentBrowserImage.thumbSize;
export const imgSize = (state, getters) =>
  getters.currentBrowserImage && getters.currentBrowserImage.imgSize;
export const displayImgSize = (state, getters) =>
  getters.hasFullImage ? getters.imgSize : getters.thumbSize;
export const flippedImgSize = (state, getters) =>
  getters.hasFullImage ? {w: getters.imgSize.h, h: getters.imgSize.w} : {w: getters.thumbSize.h, h: getters.thumbSize.w};
export const displayIsFullImage = (state, getters) => !!(getters.imgObject && getters.imgSize);
export const imgIsLoading = (state, getters) =>
  getters.currentBrowserImage && getters.currentBrowserImage.imgIsLoading;
export const thumbIsLoading = (state, getters) =>
  getters.currentBrowserImage && getters.currentBrowserImage.thumbIsLoading;
export const imgEye = (state, getters) =>
  getters.currentBrowserImage && getters.currentBrowserImage.imgEye;
export const imgTimestamp = (state, getters) =>
  getters.currentBrowserImage && getters.currentBrowserImage.imgTimeStamp;
export const imgMask = (state, getters) => 
  getters.currentBrowserImage && getters.imageBrowserContext.imageMask;
// #endregion

// #region playback
export const imageIndex = (state, getters) => {
  if (getters.browserImages.length && getters.currentBrowserImage)
    return getters.browserImages.findIndex(v => v.imgKey == getters.currentBrowserImage.imgKey);
  return 0;
};
export const isPlaying = state => !!(state.imageBrowserContext && state.imageBrowserContext.playIntervalId);
export const playRate = state => state.imageBrowserContext && state.imageBrowserContext.playRate;
// #endregion

// #region annotations
export const isAnnotating = state => state.imageBrowserContext && state.imageBrowserContext.isAnnotating;
export const annotationMode = state => state.imageBrowserContext && state.imageBrowserContext.annotationMode;
export const annotationColor = state => state.imageBrowserContext && state.imageBrowserContext.annotationColor;
export const isDragLock = state => state.imageBrowserContext && state.imageBrowserContext.isDragLock;
export const inAddMode = (state, getters) => addMode(getters.annotationMode);
export const inEditMode = (state, getters) => editMode(getters.annotationMode);
export const inDeleteMode = (state, getters) => deleteMode(getters.annotationMode);
export const inMagnifyMode = (state, getters) => magnifyMode(getters.annotationMode);
export const isMagnifying = state => state.imageBrowserContext && state.imageBrowserContext.isMagnifying;
export const inShapeFillMode = (state, getters) => shapeFillMode(getters.annotationMode);
export const annotations = state => state.imageBrowserContext && state.imageBrowserContext.annotations;
export const activeAnnotation = state => state.imageBrowserContext && state.imageBrowserContext.activeAnnotation;
export const activeIsContinuous = (state, getters) =>
  getters.activeAnnotation && getters.activeAnnotation.isContinuous;
export const annotationByPosition = state => ({ x, y }) =>
  state.imageBrowserContext && state.imageBrowserContext.annotations
  && state.imageBrowserContext.annotations.find(a => a.isInBounds(x, y));
export const annotationIndex = state => annotation =>
  state.imageBrowserContext && state.imageBrowserContext.annotations
  && state.imageBrowserContext.annotations.findIndex(a => a == annotation);
export const annotationOptions = state => {
  let context = state.imageBrowserContext;
  return {
    textSize: context && context.annotationTextSize || 40,
    lineWidth: context && context.annotationLineWidth || 5,
    color: context && context.annotationColor || ANNOTATION_COLORS.White,
    scale: context && context.deviceCalibration && context.deviceCalibration.value,
    transform: context && context.transform
  };
};
export const selectedTextSize = state => state.imageBrowserContext && state.imageBrowserContext.annotationTextSize;
export const textAnnotationToEdit = state => state.textAnnotationToEdit;
export const magnifier = state => state.imageBrowserContext && state.imageBrowserContext.magnifier;

export const shapeOutlineContext = state => state.shapeOutlineContext;
export const isShapeOutlineOpen = state => !!state.shapeOutlineContext;
export const shapeOutlineSyncContext = state => state.shapeOutlineSyncContext;

export const shapeFillContext = state => state.shapeFillContext;
export const isShapeFillOpen = state => !!state.shapeFillContext;
export const shapeFillSyncContext = state => state.shapeFillSyncContext;
// #endregion

// #region transformations
export const isFlipped = state => state.imageBrowserContext && state.imageBrowserContext.isFlipped;
export const isFlipped90 = state => state.imageBrowserContext && state.imageBrowserContext.isFlipped90;
// #endregion

// #region color settings
export const imageColorSettings = state => state.imageBrowserContext && state.imageBrowserContext.imageColorSettings;
export const grayscaleMode = (state, getters) => getters.imageColorSettings && getters.imageColorSettings.grayscaleMode;
export const brightness = (state, getters) => getters.imageColorSettings && getters.imageColorSettings.brightness;
export const contrast = (state, getters) => getters.imageColorSettings && getters.imageColorSettings.contrast;
export const gamma = (state, getters) => getters.imageColorSettings && getters.imageColorSettings.gamma;
export const greenBrightness = (state, getters) => getters.imageColorSettings && getters.imageColorSettings.greenBrightness;
export const greenContrast = (state, getters) => getters.imageColorSettings && getters.imageColorSettings.greenContrast;
// #endregion

// #region memory canvases
export const webglCanvas = state => state.imageBrowserContext && state.imageBrowserContext.webglCanvas;
export const saveCanvas = state => state.imageBrowserContext && state.imageBrowserContext.saveCanvas;
export const flattenedImageReady = state => state.imageBrowserContext && state.imageBrowserContext.flattenedImageReady;
// #endregion

// #region device configurations
export const deviceConfigs = state => state.imageBrowserContext && state.imageBrowserContext.deviceConfigs;
export const hasDeviceConfigs = (state, getters) => getters.deviceConfigs.length;
export const deviceCalibrations = (state, getters) => getters.deviceConfigs.filter(v => v.type === "magVal");
export const hasDeviceCalibrations = (state, getters) => getters.deviceCalibrations.length;
export const deviceCalibration = state => state.imageBrowserContext && state.imageBrowserContext.deviceCalibration;
// #endregion

// #region rgb-view
export const rgbSettings = state => state.imageBrowserContext && state.imageBrowserContext.rgbSettings;
export const rgbView = (state, getters) => !!getters.rgbSettings;
export const rgbIndexByMode = (state, getters) => mode => getters.rgbView && state.imageBrowserContext.getRGBIndex(mode);
export const rgbSync = (state, getters) => getters.rgbView && getters.rgbSettings.sync;
export const greenSync = (state, getters) => getters.rgbView && getters.rgbSettings.greenSync;
export const rgbExpanded = (state, getters) => getters.rgbView && getters.rgbSettings.expanded;
export const rgbViews = (state, getters) => getters.rgbView && getters.rgbSettings.views || [];
export const currentRGBView = (state, getters) => getters.rgbView && getters.rgbSettings.views[getters.rgbSettings.view];
export const currentRGBIndex = (state, getters) => getters.rgbView && getters.rgbSettings.view;
export const rgbViewByIndex = (state, getters) => index => getters.rgbView && getters.rgbSettings.views[index];
export const rgbViewsNotMatchingMain = (state, getters) => {
  if (!getters.rgbView) return [];
  let main = state.imageBrowserContext.imageColorSettings;
  return state.imageBrowserContext.rgbSettings.views
    .filter(view => {
      return view.brightness !== main.brightness
        || view.contrast !== main.contrast
        || view.gamma !== main.gamma;
    }) || [];
};
// #endregion

// #region oct
export const octDataLoading = state => state.imageBrowserContext && state.imageBrowserContext.octDataLoading;
export const currentGroup = state => state.imageBrowserContext && state.imageBrowserContext.groupName;
export const currentEye = state => state.imageBrowserContext && state.imageBrowserContext.eye;
export const currentOCTBrowserType = state => state.imageBrowserContext && state.imageBrowserContext.browserType;
export const eyeGroups = (state, getters) => {
  if (!getters.exam || !getters.currentEye) return [];
  return getters.groups(getters.exam, getters.currentEye);
};
export const showHD = state => state.imageBrowserContext && state.imageBrowserContext.showHD;
export const showETDRS = state => state.imageBrowserContext && state.imageBrowserContext.showETDRS;
export const foveaOffset = state => state.imageBrowserContext && state.imageBrowserContext.foveaOffset;

export const thicknessAnalysis = state => state.imageBrowserContext && state.imageBrowserContext.thicknessAnalysis;
export const centerAverageThickness = (state, getters) => getters.thicknessAnalysis && getters.thicknessAnalysis.centerAverageThickness;
export const overallVolume = (state, getters) => getters.thicknessAnalysis && getters.thicknessAnalysis.overallVolume;
export const overallAverageThickness = (state, getters) => getters.thicknessAnalysis && getters.thicknessAnalysis.overallAverageThickness;

export const showSegmentation = state => state.imageBrowserContext && state.imageBrowserContext.showSegmentation;
export const isMeasuring = state => state.imageBrowserContext && state.imageBrowserContext.isMeasuring;
export const measureData = state => state.imageBrowserContext && state.imageBrowserContext.measureData;
export const isBothMeasuring = state => state.imageBrowserContext && state.imageBrowserContext.bothMeasuring;
export const showThicknessMap = state => state.imageBrowserContext && state.imageBrowserContext.showThicknessMap;
export const drawAllSlices = state => state.imageBrowserContext && state.imageBrowserContext.drawAllSlices;
export const showSpectralisThicknessMapButton = state => state.imageBrowserContext && state.imageBrowserContext.groupName && (state.imageBrowserContext.groupName.toLowerCase().includes("volume") || state.imageBrowserContext.groupName.toLowerCase().includes("cube"));
export const spectralisScanTypes = state => state.imageBrowserContext && state.imageBrowserContext.examTypes;
export const spectralisScanTypeFilter = state => state.imageBrowserContext && state.imageBrowserContext.scanTypeFilter;

export const octDropdownItems = state => state.imageBrowserContext && state.imageBrowserContext.dropdownItems;

// #region reference image
export const referenceImage = state => state.imageBrowserContext && state.imageBrowserContext.referenceImage;
export const refImg = (state, getters) => getters.referenceImage && getters.referenceImage.imgHtmlObject;
export const refImgNotFound = (state, getters) =>
  !!(getters.referenceImage && getters.referenceImage.imgNotFound);
export const refImgLoading = (state, getters) => getters.referenceImage
  && (getters.referenceImage.imgIsLoading || getters.referenceImage.imgIsQueued);
export const refImgLocation = state => (x, y) => {
  if (!state.imageBrowserContext
    || !state.imageBrowserContext.refImgLocation) return { x: -1, y: -1 };
  return state.imageBrowserContext.refImgLocation(x, y);
};
// #endregion

// #region thickness map
export const relativeMapSize = state => state.imageBrowserContext && state.imageBrowserContext.relativeMapSize;
export const thicknessMapOpacity = state => state.imageBrowserContext && state.imageBrowserContext.thicknessMapOpacity;
export const thicknessMap = state => state.imageBrowserContext && state.imageBrowserContext.thicknessMap;
export const thicknessMapImg = (state, getters) => getters.thicknessMap && getters.thicknessMap.imgHtmlObject;
export const thicknessMapPalette = state => state.imageBrowserContext && state.imageBrowserContext.thicknessMapPalette;
export const thicknessMapMinThicknessUm = state => state.imageBrowserContext && state.imageBrowserContext.thicknessMapMinThicknessUm;
export const thicknessMapMaxThicknessUm = state => state.imageBrowserContext && state.imageBrowserContext.thicknessMapMaxThicknessUm;
export const thicknessMapThicknessStepUm = state => state.imageBrowserContext && state.imageBrowserContext.thicknessMapThicknessStepUm;
export const thicknessMapColorSettings = state => state.imageBrowserContext && state.imageBrowserContext.thicknessMapColorSettings;
export const thicknessDifference = state => state.imageBrowserContext && state.imageBrowserContext.thicknessDifference;
// #endregion

// #region enface image
export const enfaceImage = state => state.imageBrowserContext && state.imageBrowserContext.enfaceImage;
export const enfaceImg = (state, getters) => getters.enfaceImage && getters.enfaceImage.imgHtmlObject;
export const enfaceImgSize = state => state.imageBrowserContext && state.imageBrowserContext.enfaceImgSize;
export const enfaceImgNotFound = (state, getters) => !!(getters.enfaceImage && getters.enfaceImage.imgNotFound);
export const enfaceImgLoading = (state, getters) => getters.enfaceImage
  && (getters.enfaceImage.imgIsLoading || getters.enfaceImage.imgIsQueued);
// #endregion

// #region slices
export const getSlices = state => (keyword, exSrNo, groupName) => {
  if (!exSrNo) exSrNo = state.imageBrowserContext.exSrNo;
  if (!groupName) groupName = state.imageBrowserContext.groupName;
  return state.imageBrowserContext && state.octImageMap.filter(i =>
    i.exSrNo === exSrNo && i.groupName === groupName && i.keyword === keyword) || [];
};

// #region slice
export const slices = (state, getters) => getters.getSlices("slice");
export const sliceInfo = state => state.imageBrowserContext && state.imageBrowserContext.sliceInfo;
export const sliceCurrent = state => state.imageBrowserContext && state.imageBrowserContext.sliceCurrent;
export const sliceCurrentIndex = (state, getters) => getters.sliceCurrent && getters.sliceCurrent.index;
export const sliceCurrentEyeMarker = (state, getters) => getters.sliceCurrent && getters.sliceCurrent.eyeMarker;
export const sliceBounds = state => state.imageBrowserContext && state.imageBrowserContext.sliceBounds;

export const sliceImgObject = (state, getters) => getters.sliceCurrent && getters.sliceCurrent.imgHtmlObject;
export const slicePreviewObject = (state, getters) => getters.sliceCurrent && getters.sliceCurrent.previewHtmlObject;

export const sliceImg = (state, getters) => getters.sliceImgObject || getters.slicePreviewObject;
export const sliceImgNotFound = (state, getters) => 
  !!(getters.sliceCurrent && getters.sliceCurrent.imgNotFound);
export const sliceImgLoading = (state, getters) => getters.sliceCurrent && (getters.sliceCurrent.imgIsLoading || getters.sliceCurrent.imgIsQueued);

export const sliceHasSegmentation = (state, getters) => getters.sliceInfo && getters.sliceInfo.sliceHasSegmentation;
export const sliceSegmentationIsLoading = (state, getters) => getters.sliceCurrent && (getters.sliceCurrent.sliceSegmentationIsLoading || getters.sliceCurrent.segmentationIsQueued);
export const sliceSegmentationLayerData = (state, getters) => getters.sliceCurrent && getters.sliceCurrent.sliceSegmentationLayerData;
export const sliceSegmentationThicknessData = (state, getters) => getters.sliceCurrent && getters.sliceCurrent.sliceSegmentationThicknessData;
// #endregion

// #region composite
export const composites = (state, getters) => getters.getSlices("composite");
export const compositeInfo = state => state.imageBrowserContext && state.imageBrowserContext.compositeInfo;
export const compositeCurrent = state => state.imageBrowserContext && state.imageBrowserContext.compositeCurrent;
export const compositeCurrentIndex = (state, getters) => getters.compositeCurrent && getters.compositeCurrent.index;
export const compositeCurrentEyeMarker = (state, getters) => getters.compositeCurrent && getters.compositeCurrent.eyeMarker;
export const compositeBounds = state => state.imageBrowserContext && state.imageBrowserContext.compositeBounds;

export const compositeImgObject = (state, getters) => getters.compositeCurrent && getters.compositeCurrent.imgHtmlObject;
export const compositePreviewObject = (state, getters) => getters.compositeCurrent && getters.compositeCurrent.previewHtmlObject;

export const compositeImg = (state, getters) => getters.compositeImgObject || getters.compositePreviewObject;
export const compositeImgNotFound = (state, getters) => !!(getters.compositeCurrent && getters.compositeCurrent.imgNotFound);
export const compositeImgLoading = (state, getters) => getters.compositeCurrent && (getters.compositeCurrent.imgIsLoading || getters.compositeCurrent.imgIsQueued);

export const compositeHasSegmentation = (state, getters) => getters.compsiteSliceInfo && getters.compsiteSliceInfo.sliceHasSegmentation;
export const compositeSegmentationIsLoading = (state, getters) => getters.compositeCurrent && (getters.compositeCurrent.sliceSegmentationIsLoading || getters.compositeCurrent.segmentationIsQueued);
export const compositeSegmentationLayerData = (state, getters) => getters.compositeCurrent && getters.compositeCurrent.sliceSegmentationLayerData;
// #endregion

// #region hdVert
export const hdVerts = (state, getters) => getters.getSlices("hdVert");
export const hdVertInfo = state => state.imageBrowserContext && state.imageBrowserContext.hdVertInfo;
export const hdVertCurrent = state => state.imageBrowserContext && state.imageBrowserContext.hdVertCurrent;
export const hdVertCurrentIndex = (state, getters) => getters.hdVertCurrent && getters.hdVertCurrent.index;

export const hdVertImg = (state, getters) => getters.hdVertCurrent && getters.hdVertCurrent.imgHtmlObject;
export const hdVertImgNotFound = (state, getters) => !!(getters.hdVertCurrent && getters.hdVertCurrent.imgNotFound);
export const hdVertImgLoading = (state, getters) => getters.hdVertCurrent && (getters.hdVertCurrent.imgIsLoading || getters.hdVertCurrent.imgIsQueued);

export const hdVertHasSegmentation = (state, getters) => getters.hdVertInfo && getters.hdVertInfo.sliceHasSegmentation;
export const hdVertSegmentationIsLoading = (state, getters) => getters.hdVertCurrent && (getters.hdVertCurrent.sliceSegmentationIsLoading || getters.hdVertCurrent.segmentationIsQueued);
export const hdVertSegmentationLayerData = (state, getters) => getters.hdVertCurrent && getters.hdVertCurrent.sliceSegmentationLayerData;
// #endregion

// #region hdHorz
export const hdHorzs = (state, getters) => getters.getSlices("hdHorz");
export const hdHorzInfo = state => state.imageBrowserContext && state.imageBrowserContext.hdHorzInfo;
export const hdHorzCurrent = state => state.imageBrowserContext && state.imageBrowserContext.hdHorzCurrent;
export const hdHorzCurrentIndex = (state, getters) => getters.hdHorzCurrent && getters.hdHorzCurrent.index;

export const hdHorzImg = (state, getters) => getters.hdHorzCurrent && getters.hdHorzCurrent.imgHtmlObject;
export const hdHorzImgNotFound = (state, getters) => !!(getters.hdHorzCurrent && getters.hdHorzCurrent.imgNotFound);
export const hdHorzImgLoading = (state, getters) => getters.hdHorzCurrent && (getters.hdHorzCurrent.imgIsLoading || getters.hdHorzCurrent.imgIsQueued);

export const hdHorzHasSegmentation = (state, getters) => getters.hdHorzInfo && getters.hdHorzInfo.sliceHasSegmentation;
export const hdHorzSegmentationIsLoading = (state, getters) => getters.hdHorzCurrent && (getters.hdHorzCurrent.sliceSegmentationIsLoading || getters.hdHorzCurrent.segmentationIsQueued);
export const hdHorzSegmentationLayerData = (state, getters) => getters.hdHorzCurrent && getters.hdHorzCurrent.sliceSegmentationLayerData;

export const hasHD = state => state.hdHorzs && state.hdVerts && state.hdHorzs.length != 0 && state.hdVerts.length != 0;
// #endregion

// #region cscans
export const cscans = (state, getters)  => getters.getSlices("cscan");
export const cscanInfo = state => state.imageBrowserContext && state.imageBrowserContext.cscanInfo;
export const cscanCurrent = state => state.imageBrowserContext && state.imageBrowserContext.cscanCurrent;
export const cscanCurrentIndex = (state, getters) => getters.cscanCurrent && getters.cscanCurrent.index;

export const cscanImg = (state, getters) => getters.cscanCurrent && getters.cscanCurrent.imgHtmlObject;
export const cscanImgNotFound = (state, getters) => !!(getters.cscanCurrent && getters.cscanCurrent.imgNotFound);
export const cscanImgLoading = (state, getters) => getters.cscanCurrent && (getters.cscanCurrent.imgIsLoading || getters.cscanCurrent.imgIsQueued);
// #endregion

// #endregion

// #region color correction
export const octColorSettings = state =>
  state.imageBrowserContext && state.imageBrowserContext.octColorSettings;
export const isInverted = (state, getters) =>
  getters.octColorSettings && getters.octColorSettings.isInverted;
export const hasColorPalette = (state, getters) =>
  getters.octColorSettings && !!getters.octColorSettings.colorPalette;
// #endregion

// #region comparison multiview
export const getOCTImagesForMultiview = (state, getters) => {
  let baseline_exSrNo = getters.baseline_exSrNo, baseline_groupName = getters.baseline_groupName,
    compare_exSrNo = getters.compare_exSrNo, compare_groupName = getters.compare_groupName;

  return state.octImageMap.filter(i =>
    ((i.exSrNo === compare_exSrNo && i.groupName === compare_groupName)
      || (i.exSrNo === baseline_exSrNo && i.groupName === baseline_groupName))
    && (i.imageType !== "composite" && i.imageType !== "hidef"));
};
export const isComparisonContext = state =>
  state.imageBrowserContext && state.imageBrowserContext.isComparisonContext;
export const isLocked = state =>
  state.imageBrowserContext && state.imageBrowserContext.isLocked;
export const showFoveaAlignControl = state =>
  state.imageBrowserContext && state.imageBrowserContext.showFoveaAlignControl;
export const alignFoveas = state =>
  state.imageBrowserContext && state.imageBrowserContext.alignFoveas;
export const preferredBrowserType = state =>
  state.imageBrowserContext && state.imageBrowserContext.preferredBrowserType;
export const lockEnabled = state =>
  state.imageBrowserContext && state.imageBrowserContext.lockEnabled;
export const octExamsSameType = state =>
  state.imageBrowserContext && state.imageBrowserContext.exams || [];
export const groups = () => (exam, eye, allowedTypes, preferredType) => {
  let groups = eye === EyeTypes.OD ? exam.odGroups : exam.osGroups;
  groups.forEach(e => e.groupSeriesType = e.groupSeriesType.replace("Star", "Radial"));
  return [...groups].filter(g => g.recognized &&
    (!allowedTypes || !allowedTypes.length || allowedTypes.includes(g.browserType)))
    .sort((a, b) => {
      let aPreferred = a.browserType === preferredType;
      let bPreferred = b.browserType === preferredType;
      if (aPreferred === bPreferred) return 0;
      if (aPreferred) return -1;
      return 1;
    });
};
export const comparisonSameType = (state, getters) =>
  getters.baseline_browserType === getters.compare_browserType;
export const isSpectralisComparison = state =>
  state.imageBrowserContext && state.imageBrowserContext.isSpectralisComparison;
// #region baseline
export const baseline = state =>
  state.imageBrowserContext && state.imageBrowserContext.baseline;
export const baseline_loading = (state, getters) =>
  getters.baseline && getters.baseline.octDataLoading;
export const baseline_reference = (state, getters) => getters.baseline && getters.baseline.referenceImage;
export const baseline_refImg = (state, getters) =>
  getters.baseline_reference && getters.baseline_reference.imgHtmlObject;
export const baselineTime = (state, getters) => getters.baseline && getters.baseline.seriesMoment;
export const baselineExams = (state, getters) => {
  if (getters.compare && (getters.compare.componentName == "cirrusComparisonView" || getters.compare.componentName == "rasterComparisonView"))
    return getters.octExamsSameType
    .filter(e => e.exSrNo != getters.compare.exam.exSrNo && e.moment < getters.compare.examMoment);
  return getters.octExamsSameType
    .filter(e => !getters.compare || (e.scanType != getters.compare.exam.scanType || e.exSrNo != getters.compare.exam.exSrNo) && (e.moment <= getters.compare.seriesMoment && e.moment <= getters.compare.examMoment));
}
export const baselineGroups = (state, getters) => {
  if (!getters.baseline || !getters.baseline.exam) return [];
  return getGroups(getters, getters.baseline.exam);
};
function getGroups(getters, exam) {
  return getters.groups(exam, getters.currentEye, getters.currentOCTBrowserType, getters.preferredBrowserType);
}
export const baseline_slices = (state, getters) =>
  getters.baseline && getters.getSlices("slice", getters.baseline_exSrNo, getters.baseline_groupName);
export const baseline_sliceInfo = (state, getters) =>
  getters.baseline && getters.baseline.sliceInfo;
export const baseline_sliceCurrent = (state, getters) =>
  getters.baseline && getters.baseline.sliceCurrent;
export const baseline_sliceImg = (state, getters) =>
  getters.baseline_sliceCurrent && getters.baseline_sliceCurrent.imgHtmlObject;
export const baseline_thicknessMap = (state, getters) =>
  getters.baseline && getters.baseline.thicknessMap;
export const baseline_thicknessMapImg = (state, getters) =>
  getters.baseline_thicknessMap && getters.baseline_thicknessMap.imgHtmlObject;
export const baseline_showOverlay = (state, getters) =>
  getters.baseline && getters.baseline.showOverlay;
export const baseline_exSrNo = (state, getters) =>
  getters.baseline && getters.baseline.exSrNo;
export const baseline_groupName = (state, getters) =>
  getters.baseline && getters.baseline.groupName;
export const baseline_exam = (state, getters) =>
  getters.baseline && getters.baseline.exam;
export const baseline_browserType = (state, getters) =>
  getters.baseline && getters.baseline.browserType;
export const baseline_dropdownItems = (state, getters) => 
  getters.baseline && getters.baseline.dropdownItems;
export const baseline_selectedDropdownItem = (state, getters) => 
  getters.baseline && getters.baseline.selectedDropdownItem;
// #endregion

// #region compare
export const compare = state =>
  state.imageBrowserContext && state.imageBrowserContext.compare;
export const compare_loading = (state, getters) =>
  getters.compare && getters.compare.octDataLoading;
export const compare_reference = (state, getters) => getters.compare && getters.compare.referenceImage;
export const compare_refImg = (state, getters) =>
  getters.compare_reference && getters.compare_reference.imgHtmlObject;
export const compareExams = (state, getters) => getters.octExamsSameType;
export const compareGroups = (state, getters) => {
  if (!getters.compare || !getters.compare.exam) return [];
  return getGroups(getters, getters.compare.exam);
};

export const compare_slices = (state, getters) =>
  getters.compare && getters.getSlices("slice", getters.compare_exSrNo, getters.compare_groupName);
export const compare_sliceInfo = (state, getters) =>
  getters.compare && getters.compare.sliceInfo;
export const compare_sliceCurrent = (state, getters) =>
  getters.compare && getters.compare.sliceCurrent;
export const compare_sliceImg = (state, getters) =>
  getters.compare_sliceCurrent && getters.compare_sliceCurrent.imgHtmlObject;
export const compare_thicknessMap = (state, getters) =>
  getters.compare && getters.compare.thicknessMap;
export const compare_thicknessMapImg = (state, getters) =>
  getters.compare_thicknessMap && getters.compare_thicknessMap.imgHtmlObject;
export const compare_showOverlay = (state, getters) =>
  getters.compare && getters.compare.showOverlay;
export const compare_exSrNo = (state, getters) =>
  getters.compare && getters.compare.exSrNo;
export const compare_groupName = (state, getters) =>
  getters.compare && getters.compare.groupName;
export const compare_browserType = (state, getters) =>
  getters.compare && getters.compare.browserType;
export const compare_dropdownItems = (state, getters) => 
  getters.compare && getters.compare.dropdownItems;
export const compare_selectedDropdownItem = (state, getters) => 
  getters.compare && getters.compare.selectedDropdownItem;
// #endregion

// #endregion

// #endregion

// #region hvf
export const hvfExams = state => state.imageBrowserContext && state.imageBrowserContext.exams;
export const hvfEye = state => state.imageBrowserContext && state.imageBrowserContext.eyeFilter;
export const hvfView = state => state.imageBrowserContext && state.imageBrowserContext.view;
export const hvfIndex = (state, getters) => getters.hvfView && getters.hvfView.index;
export const hvfImageCount = (state, getters) => getters.hvfView && (getters.hvfView.maxIndex + 1) || 0;
export const hvfOSImages = (state, getters) => getters.hvfView && getters.hvfView.osImages;
export const hvfOSImage = (state, getters) => getters.hvfView && getters.hvfView.osImage;
export const hvfODImages = (state, getters) => getters.hvfView && getters.hvfView.odImages;
export const hvfODImage = (state, getters) => getters.hvfView && getters.hvfView.odImage;
// #endregion

// #region hvf multiview
export const hvfViews = state => state.imageBrowserContext && state.imageBrowserContext.views || [];
// #endregion

// #endregion

// #region image loading queue
export const imageQueue = state => state.imageQueue;
export const octFullQueue = state => state.octFullQueue;
export const octPreviewQueue = state => state.octPreviewQueue;
export const octSegmentationQueue = state => state.octSegmentationQueue;
// #endregion

// #region patient exam multiview
export const patientExamMultiviewContext = state => state.patientExamMultiviewContext;
export const multiviewEye = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.currentEye;
export const deviceFilter = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.deviceFilter || [];
export const dateFilter = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.dateFilter || [];
export const deviceList = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.deviceList || [];
export const dateList = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.dateList || [];
export const patientExamMultiviewImageObjects = state =>
  state.patientExamMultiviewImageObjects;
export const multiviewExams = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.exams || [];
export const filteredMultiviewExams = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.filteredExams || [];
export const currentMultiviewExams = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.currentExams || [];
export const selectedMultiviewExams = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.selectedExams || [];
export const multiviewAllExamsSelected = state => {
  if (!state.patientExamMultiviewContext) return false;
  return state.patientExamMultiviewContext.exams.length === state.patientExamMultiviewContext.selectedExams.length;
};
export const multiviewImages = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.images || [];
export const filteredmultiviewImages = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.filteredImages || [];
export const currentMultiviewImages = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.currentImages || [];
export const selectedMultiviewImages = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.selectedImages || [];
export const multiviewImagesByExSrNo = (state, getters) =>
  exSrNo => getters.multiviewImages.filter(i => i.exSrNo === exSrNo);
export const imageIsSelectedInMultiview = (state, getters) =>
  image => getters.selectedMultiviewImages.includes(image);
export const filteredMultiviewImagesByExSrNo = (state, getters) =>
  exSrNo => getters.filteredmultiviewImages.filter(i => i.exSrNo === exSrNo);
export const multiviewIsCollapsed = state =>
  state.patientExamMultiviewContext && state.patientExamMultiviewContext.isCollapsed;
// #endregion

// #region proofsheet context
export const proofsheetContext = state =>
  state.proofsheetContext;
export const proofsheetFilterOption = state =>
  state.proofsheetContext && state.proofsheetContext.filterOption;
export const proofsheetShowAll = (state, getters) =>
  getters.proofsheetFilterOption === "All Images";
export const proofsheetEyeFilter = state =>
  state.proofsheetContext && state.proofsheetContext.currentEye;
export const proofsheetImages = state =>
  state.proofsheetContext && state.proofsheetContext.images || [];
export const filteredProofsheetImages = (state, getters) =>
{
  if (getters.proofsheetShowAll)
    return state.proofsheetContext && state.proofsheetContext.filteredImages || [];
  return getters.selectedProofsheetImages;
}
export const currentProofsheetImages = state =>
  state.proofsheetContext && state.proofsheetContext.currentImages || [];
export const selectedProofsheetImages = state =>
  state.proofsheetContext && state.proofsheetContext.selectedImages || [];
export const imageIsSelectedInProofsheet = (state, getters) => image =>
  getters.selectedProofsheetImages.includes(image);
export const proofsheetAllSelected = (state) =>
state.proofsheetContext && state.proofsheetContext.allSelected;
export const isDeletingImages = state =>
  state.proofsheetContext && state.proofsheetContext.isDeletingImages;
export const proofsheetImagesToDelete = (state, getters) =>
  (getters.isDeletingImages && getters.selectedProofsheetImages) || [];
export const activeDownloadText = state =>
  state.activeDownload.text;
export const activeDownloadLink = state =>
  state.activeDownload.link;
export const isMarkingImages = state =>
  state.proofsheetContext && state.proofsheetContext.isMarkingImages;
export const proofsheetImagesToMark = (state, getters) =>
  (getters.isMarkingImages && getters.selectedProofsheetImages) || [];
// #endregion

// #region placeholder context for exam multiview buttons
export const placeholderContext = state => state.placeholderContext;
// #endregion

// #region overlay context
export const overlayContext = state => state.overlayContext;
export const previousOverlayImages = state => state.originalOverlaySettings && state.originalOverlaySettings.sourceImages || [];
export const addingImagesForOverlay = state => !!state.originalOverlaySettings;
export const loadingMessage = state => state.loadingMessage;
export const i2kImageByKey = state => key => state.i2kImages.find(i => i.imgKey === key);
export const i2kImagesByFlSrNos = state => flSrNos => state.i2kImages.filter(i => i.flSrNos === flSrNos);
// #endregion

// #region stereo context
export const stereoContext = state => state.stereoContext;
export const stereoImagePairs = state => state.stereoContext && state.stereoContext.imagePairs || [];
export const stereoSelectedPair = state => state.stereoContext && state.stereoContext.selectedPair;
// #endregion

// #region print preview context
export const printPreviewContext = state => state.printPreviewContext;
export const printPreviewPageLayout = state => state.printPreviewContext && state.printPreviewContext.pageLayout;
export const printPreviewDisplayHeader = state => state.printPreviewContext && state.printPreviewContext.displayHeader;
export const printPreviewImagesPerSheet = state => state.printPreviewContext && state.printPreviewContext.imagesPerSheet;
export const printPreviewCurrentPage = state => state.printPreviewContext && state.printPreviewContext.currentPage;
export const printPreviewIsPrinting = state => state.printPreviewContext && state.printPreviewContext.isPrinting;
export const printPreviewSheetNum = state => state.printPreviewContext && state.printPreviewContext.sheetNum;
export const printPreviewImageNum = state => state.printPreviewContext && state.printPreviewContext.imageNum;
export const printPreviewImages = state => state.printPreviewContext && state.printPreviewContext.images || [];

export const isLoadingAppPrintImages = state => state.isLoadingAppPrintImages;
// #endregion

// #region side by side context
export const sideBySideContext = state => state.sideBySideContext;
export const sideBySideDisplayAnnotation = state => state.sideBySideContext && state.sideBySideContext.displayAnnotation;
export const sideBySideIsSynced = state => state.sideBySideContext && state.sideBySideContext.sync;
export const sideBySideCanSync = (state, getters) => {
  let context = getters.sideBySideContext;
  if (!context) return false;
  if (!context.leftContext
    || !context.leftContext.image
    || !context.leftContext.image.imgSize) return false;
  if (!context.rightContext
    || !context.rightContext.image
    || !context.rightContext.image.imgSize) return false;

  let leftSize = context.leftContext.image.imgSize;
  let rightSize = context.rightContext.image.imgSize;
  return leftSize.w === rightSize.w && leftSize.h === rightSize.h;
};

export const sideBySideLeftContext = state => state.sideBySideContext && state.sideBySideContext.leftContext;
export const sideBySideLeftExSrNo = (_, getters) => getters.sideBySideLeftContext && getters.sideBySideLeftContext.exSrNo;
export const sideBySideLeftImage = (_, getters) => getters.sideBySideLeftContext && getters.sideBySideLeftContext.image;
export const sideBySideLeftImages = (_, getters) => getters.sideBySideLeftContext && getters.sideBySideLeftContext.images || [];
export const sideBySideLeftIndex = (_, getters) => {
  if (!getters.sideBySideLeftImage) return 0;
  return getters.sideBySideLeftImages.findIndex(v => v.imgKey == getters.sideBySideLeftImage.imgKey);
};
export const sideBySideLeftEye = (_, getters) => {
  let context = getters.sideBySideLeftContext;
  let image = context && context.image;
  return image && image.imgEye;
}

export const sideBySideLeftTimestamp = (_, getters) => {
  let context = getters.sideBySideLeftContext;
  let image = context && context.image;
  return image && image.imgTimeStamp;
}

export const sideBySideRightContext = state => state.sideBySideContext && state.sideBySideContext.rightContext;
export const sideBySideRightExSrNo = (_, getters) => getters.sideBySideRightContext && getters.sideBySideRightContext.exSrNo;
export const sideBySideRightImage = (_, getters) => getters.sideBySideRightContext && getters.sideBySideRightContext.image;
export const sideBySideRightImages = (_, getters) => getters.sideBySideRightContext && getters.sideBySideRightContext.images || [];
export const sideBySideRightIndex = (_, getters) => {
  if (!getters.sideBySideRightImage) return 0;
  return getters.sideBySideRightImages.findIndex(v => v.imgKey == getters.sideBySideRightImage.imgKey);
};
export const sideBySideRightEye = (_, getters) => {
  let context = getters.sideBySideRightContext;
  let image = context && context.image;
  return image && image.imgEye;
}

export const sideBySideRightTimestamp = (_, getters) => {
  let context = getters.sideBySideRightContext;
  let image = context && context.image;
  return image && image.imgTimeStamp;
}
// #endregion

// #region browser stack
export const browserStack = state => state.browserStack;
export const topBrowser = state => state.browserStack.length ? state.browserStack[state.browserStack.length - 1] : null;
export const imagesForOpenExams = (state, getters) => getters.imagesForExams(state.openedExams);
export const openedExams = state => state.openedExams;
// #endregion

// #region video viewer
export const videoViewer = state => state.videoViewer;
export const videoPtSrNo = state => state.videoViewer && state.videoViewer.ptSrNo;
export const videoExSrNo = state => state.videoViewer && state.videoViewer.exSrNo;
export const videoFileName = state => state.videoViewer && encodeURIComponent(state.videoViewer.imgData);
export const videoEye = state => state.videoViewer && state.videoViewer.imgEye;
// #endregion

// #region knowledge center
export const knowledgeCenterSettings = state => state.knowledgeCenterSettings;
export const videoLibrary = state => state.videoLibrary;
export const knowledgeCenterVideoSrc = state => state.knowledgeCenterVideoSrc;
export const isKnowledgeCenterVideo = state => state.knowledgeCenterVideoSrc != null;
export const bestPracticesEntries = state => state.bestPracticesEntries;